import React from 'react';
import '../css/NavBar.css';
const NavBar = () => {
  return (
    <div className="nav-bar">
      {/* 空的导航栏 */}
    </div>
  );
};

export default NavBar;
